import axios from "axios";


type Admin = {
  username: string;
  password: string;
 }
export const getAdmin = async (credintials:Admin) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/admin`,//
      credintials
    );
    return response.data;
  } catch (error) {
    // console.error("Error fetching admin data:", error);
    throw error;
  }
};
export const addAdmin = async (adminData:Admin) => {
  try {
   
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/add-admin`,
      adminData
    );
    return response.data;
  } catch (error) {
    console.error("Error adding admin:", error);
    throw error;
  }
};
export const updateAdmin = async (adminId:number, adminData:Admin) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/admin/${adminId}`,
      adminData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating admin:", error);
    throw error;
  }
};
export const deleteAdmin = async (adminId:number) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/admin/${adminId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting admin:", error);
    throw error;
  }
};



export const getAdminInfo = async (token: string | null) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin-info`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    return response.data;
  } catch (error) {
    console.error("Error fetching admin info:", error);
    throw error;
  }
};